import React from 'react'
import PropTypes from 'prop-types'

const ContactFormModal = props => (
  <div className="contact-modal">
    <p>{props.message}</p>
  </div>
)

ContactFormModal.propTypes = {
  message: PropTypes.string.isRequired,
}

export default ContactFormModal



// WEBPACK FOOTER //
// /opt/build/repo/src/components/ContactFormModal.js